// The one mobile breakpoint hook (mobile overhaul Phase 0, §0.1). Every
// component that needs a ≤880px branch reads this — never window.innerWidth.
// 880px is the existing CSS breakpoint; desktop ≥881px must stay untouched.
// One MediaQueryList and one listener serve every subscriber (rows, cells
// and inline fields all call this), so a long list costs nothing extra.

import { useSyncExternalStore } from 'react';

export const MOBILE_QUERY = '(max-width: 880px)';

const subscribers = new Set<() => void>();
let mql: MediaQueryList | null = null;

function ensureQuery(): MediaQueryList | null {
  if (mql) return mql;
  if (typeof window === 'undefined' || !window.matchMedia) return null;
  mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener('change', () => subscribers.forEach((fn) => fn()));
  return mql;
}

function subscribe(onChange: () => void): () => void {
  ensureQuery();
  subscribers.add(onChange);
  return () => subscribers.delete(onChange);
}

function snapshot(): boolean {
  return ensureQuery()?.matches ?? false;
}

/** True at ≤880px. SSR-safe (false without a window). */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}

/** Non-hook read for event handlers and helpers outside React. */
export function isMobileViewport(): boolean {
  return snapshot();
}
